import React, { useEffect, useRef } from 'react';
import './LegalPage.css';
 
const PrivacyPage = () => {
  const observerRef = useRef(null);
 
  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observerRef.current?.observe(el));
    return () => observerRef.current?.disconnect();
  }, []);
 
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="section-container">
          <div className="legal-hero-content animate-on-scroll">
            <h1 className="legal-title">
              Politique de <span className="text-gradient">confidentialité</span>
            </h1>
            <p className="legal-subtitle">Conformément au Règlement Général sur la Protection des Données (RGPD)</p>
          </div>
        </div>
      </section>
 
      <section className="section-padding">
        <div className="section-container">
          <div className="legal-content animate-on-scroll">
 
            <div className="legal-block">
              <h2>1. Responsable du traitement</h2>
              <p>
                Le responsable du traitement des données personnelles collectées sur ce site est :
              </p>
              <ul>
                <li><strong>Sabrina Baala — SYNA</strong></li>
                <li><strong>Email :</strong> <a href="mailto:contact@synaprocess.fr">contact@synaprocess.fr</a></li>
                <li><strong>Adresse :</strong> Paris, France</li>
              </ul>
            </div>
 
            <div className="legal-block">
              <h2>2. Données collectées</h2>
              <p>Dans le cadre de l'utilisation du formulaire de contact, nous collectons les données suivantes :</p>
              <ul>
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone (facultatif)</li>
                <li>Nom de l'entreprise (facultatif)</li>
                <li>Contenu du message</li>
              </ul>
            </div>
 
            <div className="legal-block">
              <h2>3. Finalité du traitement</h2>
              <p>Les données collectées sont utilisées uniquement pour :</p>
              <ul>
                <li>Répondre à vos demandes de contact</li>
                <li>Planifier et confirmer des rendez-vous</li>
                <li>Vous envoyer des informations relatives à nos services si vous en avez fait la demande</li>
              </ul>
            </div>
 
            <div className="legal-block">
              <h2>4. Durée de conservation</h2>
              <p>
                Vos données personnelles sont conservées pendant une durée maximale de <strong>3 ans</strong> à compter de notre dernier échange, conformément aux recommandations de la CNIL.
              </p>
            </div>
 
            <div className="legal-block">
              <h2>5. Partage des données</h2>
              <p>
                Vos données ne sont jamais vendues ni cédées à des tiers. Elles peuvent être transmises aux prestataires techniques suivants dans le cadre strict de leur mission :
              </p>
              <ul>
                <li><strong>EmailJS</strong> — envoi des emails de contact</li>
                <li><strong>Calendly</strong> — gestion des rendez-vous</li>
                <li><strong>IONOS</strong> — hébergement du site</li>
              </ul>
            </div>
 
            <div className="legal-block">
              <h2>6. Vos droits</h2>
              <p>Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul>
                <li><strong>Droit d'accès</strong> — consulter les données vous concernant</li>
                <li><strong>Droit de rectification</strong> — corriger des données inexactes</li>
                <li><strong>Droit à l'effacement</strong> — demander la suppression de vos données</li>
                <li><strong>Droit d'opposition</strong> — vous opposer au traitement de vos données</li>
              </ul>
              <p style={{marginTop: '1rem'}}>
                Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@synaprocess.fr">contact@synaprocess.fr</a>
              </p>
            </div>
 
            <div className="legal-block">
              <h2>7. Cookies</h2>
              <p>
                Ce site n'utilise pas de cookies de tracking ou publicitaires. Seuls des cookies techniques strictement nécessaires au bon fonctionnement du site peuvent être déposés.
              </p>
            </div>
 
            <div className="legal-block">
              <h2>8. Contact & réclamation</h2>
              <p>
                Pour toute question relative à vos données personnelles, contactez-nous à <a href="mailto:contact@synaprocess.fr">contact@synaprocess.fr</a>. Vous pouvez également introduire une réclamation auprès de la <strong>CNIL</strong> : <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">www.cnil.fr</a>.
              </p>
            </div>
 
          </div>
        </div>
      </section>
    </div>
  );
};
 
export default PrivacyPage;